/* UserInputSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _24 = "._2hwxutpp{margin-right:var(--ds-space-150,9pt)}";
const _23 = "._1wpz1y6m{align-self:flex-start}";
const _22 = "._1e0c1o8l{display:inline-block}";
const _21 = "._18u0pxbi{margin-left:var(--ds-space-200,1pc)}";
const _20 = "._2hwx1b66{margin-right:var(--ds-space-050,4px)}";
const _19 = "@media not all and (min-width:64rem){._gu181h6o{text-align:center}._1mjb1nu9{display:inline}}";
const _18 = "._vwz4gktf{line-height:20px}";
const _17 = "._1wybpxbi{font-size:var(--ds-space-200,1pc)}";
const _16 = "@media not all and (min-width:64rem){._2osn1yov{gap:var(--ds-space-100,10px)}._na0i1bp4{flex-direction:column}}";
const _15 = "._1eq11h6o label{align-items:center}";
const _14 = "._21vq1u1b [type=radio]{width:34px}";
const _13 = "._17im1u1b [type=radio]{height:34px}";
const _12 = "._10nt1txw [role=radiogroup]{display:flex}";
const _11 = "._1wyboxwj{font-size:.875rem}";
const _10 = "._vchh18uv{box-sizing:initial}";
const _9 = "@media not all and (min-width:64rem){._2osnpxbi{gap:var(--ds-space-200,1pc)}._na0i1bp4{flex-direction:column}}";
const _8 = "._125x1j6v input{font-size:1rem}";
const _7 = "._psgkrbzz input{color:#0052cc}";
const _6 = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const _5 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _4 = "._4cvr1h6o{align-items:center}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import { Box, xcss } from '@atlaskit/primitives';
import { media } from '@atlaskit/primitives/responsive';
import { Radio } from '@atlaskit/radio';
import TextField from '@atlaskit/textfield';
import { colors } from '@atlaskit/theme';
import Tooltip from '@atlaskit/tooltip';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { H5 } from '@atlassian/mpac-primitives';
import { MarketplaceBillingCycle as BillingCycleValues } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { pricingCalculatorUserCountBlurEvent } from '../../../../../../AnalyticsHelper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "@media not all and (min-width:64rem){._pffpzgxb{border-bottom:1px solid var(--ds-border,#091e4224)}._1hwcxy5q{padding-bottom:var(--ds-space-400,2pc)}._1s4p1osq{width:100%}}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const UserCountContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _pffpzgxb _1hwcxy5q _1s4p1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserCountContainer.displayName = 'UserCountContainer';
}
const UserInputContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _4, _5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _otyrxy5q _19pk1ejb _psgkrbzz _125x1j6v _2osnpxbi _na0i1bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserInputContainer.displayName = 'UserInputContainer';
}
const BillingCycleType = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _4, _, _11, _6, _12, _13, _14, _15, _16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_vchh18uv _4cvr1h6o _1e0c1txw _1wyboxwj _19pk1ejb _10nt1txw _17im1u1b _21vq1u1b _1eq11h6o _2osn1yov _na0i1bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BillingCycleType.displayName = 'BillingCycleType';
}
const UserInputPrompt = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "label",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _17, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1wybpxbi _vwz4gktf _gu181h6o _1mjb1nu9", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserInputPrompt.displayName = 'UserInputPrompt';
}
const UserInput = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2hwx1b66 _18u0pxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserInput.displayName = 'UserInput';
}
const InfoIcon = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1o8l _1wpz1y6m", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InfoIcon.displayName = 'InfoIcon';
}
const BillingCycleText = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_24]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2hwxutpp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BillingCycleText.displayName = 'BillingCycleText';
}
const radioGroupStyle = xcss({
  display: 'flex',
  lineHeight: '1.75rem',
  gap: 'space.200'
});
const textFieldStyle = {
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  padding: "var(--ds-space-100, 10px)",
  gap: "var(--ds-space-200, 16px)"
};
const UserInputSection = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleUserCountBlur = () => {
    fireAnalyticsEvent(pricingCalculatorUserCountBlurEvent(props.billingCycle, props.userCount));
  };
  const DisplayRadioButtons = () => {
    const radioGroupName = 'productBillingCycle';
    const options = [{
      value: BillingCycleValues.Monthly,
      label: 'Monthly',
      name: radioGroupName
    }, {
      value: BillingCycleValues.Annual,
      label: 'Annual',
      name: radioGroupName
    }];
    const onPromotionTypeChange = event => {
      const value = event.currentTarget.value === BillingCycleValues.Monthly ? BillingCycleValues.Monthly : BillingCycleValues.Annual;
      props.onBillingCycleToggle(value);
    };
    return /*#__PURE__*/_jsxs(BillingCycleType, {
      role: "radiogroup",
      "aria-labelledby": "billing-cycle-label",
      children: [/*#__PURE__*/_jsx(BillingCycleText, {
        id: "billing-cycle-label",
        children: "Product billing cycle:"
      }), /*#__PURE__*/_jsx(Box, {
        xcss: radioGroupStyle,
        children: options.map(_ref8 => {
          let {
            value,
            label,
            name
          } = _ref8;
          return /*#__PURE__*/_jsx(Radio, {
            value: value,
            label: label,
            name: name,
            isChecked: value === props.billingCycle,
            onChange: onPromotionTypeChange
          }, value);
        })
      })]
    });
  };
  const onUserCountChangeHandler = event => {
    const value = parseInt(event.target.value) || 0;
    props.onUserCountChange(value);
  };
  return /*#__PURE__*/_jsxs(UserCountContainer, {
    children: [/*#__PURE__*/_jsx(H5, {
      as: "h3",
      children: "Get an estimate for your team"
    }), /*#__PURE__*/_jsx(DisplayRadioButtons, {}), /*#__PURE__*/_jsxs(UserInputContainer, {
      children: [/*#__PURE__*/_jsxs(UserInputPrompt, {
        htmlFor: "no-of-user-input-field",
        children: ["Number of users in your product instance", /*#__PURE__*/_jsx(InfoIcon, {
          children: /*#__PURE__*/_jsx(Tooltip, {
            content: "Enter the number of users specified for your ".concat(props.compatibleProduct.name, " instance in Settings then User Management."),
            position: "right",
            children: /*#__PURE__*/_jsx(EditorPanelIcon, {
              size: "small",
              label: ""
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(UserInput, {
        children: [/*#__PURE__*/_jsx(TextField, {
          id: "no-of-user-input-field",
          type: "text",
          pattern: "[0-9]+",
          min: 0,
          width: 100,
          value: props.userCount === 0 ? '' : props.userCount.toString(),
          onBlur: handleUserCountBlur,
          onChange: onUserCountChangeHandler,
          style: textFieldStyle,
          "aria-describedby": "hint-for-input",
          testId: "no-of-user-input-field"
        }), /*#__PURE__*/_jsx(VisuallyHidden, {
          id: "hint-for-input",
          children: "Value entered should be a number."
        })]
      })]
    })]
  });
};
export default UserInputSection;